import {
  StyledButtonsDiv,
  StyledDeclineButtonContainer,
  StyledProvideButtonContainer,
  StyledButton,
} from './ButtonSectionStyle';
import { h } from 'preact';

export default function (props) {
  const renderProvideButton = (props) => (
    <StyledButton
      id="kplProvideButton"
      className="btn btn-wide defHeight no-border"
      name="provideButtonText"
      type="button"
      onClick={e => props.onProvideFeedbackClicked(e)}
      buttonColor={props.provideButtonColor}
      textColor={props.provideButtonTextColor}
      isWCAG={props.isWCAG}
      role="button"
      isInviteReflow={props.isInviteReflow}
    >
      {props.provideButtonText}
    </StyledButton>
  );

  const renderDeclineButton = (props) => (
    <StyledButton
      onClick={props.onDeclineButtonClicked}
      id="kplDeclineButton"
      className={`btn btn-wide btn-default defHeight no-border ${props.isWCAG ? 'wcag-decline-button-contrast' : ''}`}
      type="button"
      buttonColor={props.declineButtonColor}
      textColor={props.declineButtonTextColor}
      isWCAG={props.isWCAG}
      isDeclineButton
      role="button"
      isInviteReflow={props.isInviteReflow}
    >
      {props.declineButtonText}
    </StyledButton>
  );

  return props?.isInviteReflow ? (
    <StyledButtonsDiv className="btnDiv" isInviteReflow={props.isInviteReflow}>
      {renderProvideButton(props)}
      {renderDeclineButton(props)}
    </StyledButtonsDiv>
  ) : (
    <StyledButtonsDiv className="btnDiv">
      <StyledDeclineButtonContainer className="declineButtonLi" isDirectionRtl={props.isDirectionRtl}>
        <div className="declineButtonTextDiv">
          {renderDeclineButton(props)}
        </div>
      </StyledDeclineButtonContainer>
      <StyledProvideButtonContainer className="provideButtonLi">
        <div className="provideButtonTextDiv">
          {renderProvideButton(props)}
        </div>
      </StyledProvideButtonContainer>
    </StyledButtonsDiv>
  )
};
